<template>
  <div class="container">
    <div class="alert alert-info" role="alert" v-show="showMessage">
      Success Delete
    </div>
    <ModalConfirm 
      modalId="bannerModal" 
      :text="alert_modal_text" 
      @onClick="deleteBanner(id)"
      :center="true" :buttonConfig="{
          cancelText: 'CANCEL',
          confirmText: `CONFIRM`
        }" />

    <!-- MODAL IMAGE -->
    <div
      class="modal fade"
      id="modalImage"
      tabindex="-1"
      aria-labelledby="modalImageLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="image-container">
              <Image :src="selectedImage" className="rounded image-detail" />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-lg btn-outline-danger fw-bold"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Banner List-->
    <TableBasic :payload="payload" @onChange="changeParameter">
			<template v-slot:banner_image="{data}">
				<div class="d-flex justify-content-start">
					<img :src="data.image_url" width="154" height="60" class="rounded me-3" v-if="data.image_url"
						@error="handleImageError(data)" />
					<img src="@/assets/images/ic_preview.png" width="24" height="24"  
          @click="handleSelectImage(data.image_url)"
          data-bs-toggle="modal"
          data-bs-target="#modalImage"
          />
				</div>
			</template>
      <template v-slot:displayed_in="{data}">
				<div class="d-flex justify-content-start capitalize">
          {{filters.arrToString (data.displayed_in)}}
				</div>
			</template>
			<template v-slot:banner_url="{ value }">
				<div class="d-flex flex-column fw-bold">
					<a target="_blank" :href="value" 
						class="text-decoration-none wrap-cust"
						style="color: #5e50a1;"
   
					>
					{{value}}
					</a>
				</div>
			</template>
      <template v-slot:actions="{ value }">
        <div>
          <router-link
            :to="'/marketing/' + value.url"
            class="btn border-0"
            :class="value.edit == 'disable' ? 'disabled' : ''"
          >
            <img src="@/assets/ic_edit.svg" alt="edit"/>
          </router-link>
          <button class="btn" data-bs-toggle="modal" data-bs-target="#bannerModal"
            @click="setIdBanner(value.id,value.name)">
            <font-awesome-icon icon="fa-solid fa-ban" class="text-danger" />
          </button>
        </div>
      </template>
		</TableBasic>
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import Image from "@/components/Image.vue";

export default {
  components: {
    TableBasic,
    ModalConfirm,
    Image,
  },
  data() {
    return {
      payload: {
				filter_custom: true,
				filterList: [
					{
						label : "Filter by Created Date Newest",
						value: "created_at_desc"
					},
          {
						label : "Filter by Created Date Oldest",
						value: "created_at_asc"
					},
					{
						label : "Filter by Name A-Z",
						value: "banner_name_asc"
					},
          {
						label : "Filter by Name Z-A",
						value: "banner_name_desc"
					},
          {
						label : "Filter by Url A-Z",
						value: "banner_url_asc"
					},
          {
						label : "Filter by Url Z-A",
						value: "banner_url_desc"
					},
				],
				search: true,
				searchPlaceholder: 'ID or Name',
				searchContainerStyle: {
					maxWidth: '235px'
				},
				button_name: "Add Banner",
				button_link: "/marketing/banners/add-new",
				icon_button: "add",
				checkbox: false,
				addDisabled: false,
				hide_reset_filter: true,
        header: [
          {
            key: "banner_name",
            label: "BANNER NAME",
            class: "text-left",
          },
          {
            key: "banner_image",
            label: "BANNER IMAGE",
            class: "text-left",
          },
          {
            key: "banner_url",
            label: "BANNER'S URL",
            class: "text-left",
          },
          {
            key: "displayed_in",
            label: "DISPLAY IN",
            class: "text-left",
          },
          {
            key: "actions",
            label: "Actions",
            class: "text-center",
          },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
      },
      id:"",
      alert_modal_text:"",
      searchInput:"",
      filterValue:"created_at_desc",
      selectedImage:"",
      showMessage: false
    };
  },
  methods : {
    getData() {
      const payload = {
      }
      if (this.searchInput != "") {
        payload.filter = this.searchInput
      }

      if (this.filterValue != "") {
        if(this.filterValue == "created_at_desc" ){
          payload.sort = "created_at"
          payload.sort_type = -1
        }else if(this.filterValue == "created_at_asc" ){
          payload.sort = "created_at"
          payload.sort_type = 1
        }else if(this.filterValue == "banner_name_asc" ){
          payload.sort = "banner_name"
          payload.sort_type = 1
        }else if(this.filterValue == "banner_name_desc" ){
          payload.sort = "banner_name"
          payload.sort_type = -1
        }else if(this.filterValue == "banner_url_asc" ){
          payload.sort = "banner_url"
          payload.sort_type = 1
        }else if(this.filterValue == "banner_url_desc" ){
          payload.sort = "banner_url"
          payload.sort_type = -1
        }
      }

      this.$store
      .dispatch("banner/getAll",payload)
      .then((response) => {
         this.payload.value = this.$store.getters['banner/bannerItems']
         this.payload.addDisabled = !response.data.data.is_can_create
      })
      .catch((error) => {
        console.log(error);
      });
    },
    setIdBanner(value, name) {
      this.alert_modal_text =  'Are you sure to delete banner "'+name+'"?'
      this.id = value
    },
    async deleteBanner(value) {
      try {
        await this.$store.dispatch("banner/delete", value)
        this.showMessage = true
        setTimeout(() => {
          this.showMessage = false
          this.getData()
        }, 1500);
      } catch (error) {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      }
    },
    changeParameter(value) {
      this.searchInput = value.search
      this.payload.sortType = value.sort_type
      this.payload.sortBy = value.sort_by
      if(value?.filter?.value){
        this.filterValue = value.filter.value
      }
      this.getData()
    },
    handleSelectImage(src) {
      if (src) {
        this.selectedImage = src;
      }
    },
  },
  mounted(){
    
    this.getData()
  }
};
</script>

<style scoped lang="scss">
.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.image-detail {
  object-fit: contain;
  background-color: #f3f2f8;
  width: 100%;
  max-width: 480px;
  height: 480px;
}
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: absolute;
  background-color: rgba(65, 64, 66, 0.4);
  inset: 0;
  padding: 10px 15px;
  cursor: pointer;
  span {
    font-size: 12px;
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
}
.modal-content {
  padding: 2rem;
}
.modal-footer {
  justify-content: flex-start;
  border-top: none;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 2rem;
}
.img-display {
  cursor: pointer;
  object-fit: contain;
  min-width: 100px;
  min-height: 100px;
  width: 100px;
  height: 100px;
  background-color: #f3f2f8;
}
.error-border {
  border: 1px red solid !important;
}

td {
  vertical-align: middle;
}
.btn {
  &.disable {
    cursor: default;
    border: none;
  }
}
.wrap-cust{
  white-space: pre-wrap;      /* CSS3 */   
  white-space: -moz-pre-wrap; /* Firefox */    
  white-space: -pre-wrap;     /* Opera <7 */   
  white-space: -o-pre-wrap;   /* Opera 7 */    
  word-wrap: break-word;      /* IE */
  display:inline-block;
  width: 200px;
  overflow-wrap: break-word;
}
</style>

